import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { Button } from '@/components/Button';

interface DeleteCustomCategoryDialogProps {
  isOpen: boolean;
  categoryName: string | null;
  isDeleting: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

/**
 * カスタムカテゴリ削除確認ダイアログ
 */
export default function DeleteCustomCategoryDialog({
  isOpen,
  categoryName,
  isDeleting,
  onClose,
  onConfirm,
}: DeleteCustomCategoryDialogProps) {
  return (
    <AlertDialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>区分を削除しますか？</AlertDialogTitle>
        </AlertDialogHeader>
        <div className="p-lg">
          <AlertDialogDescription>
            {categoryName && (
              <span className="block text-sm text-gray-600">
                「<span className="font-bold text-gray-800">{categoryName}</span>
                」を削除します。この操作は取り消せません。
              </span>
            )}
          </AlertDialogDescription>
        </div>
        <AlertDialogFooter>
          <AlertDialogCancel asChild>
            <Button color="secondary" size="md">
              キャンセル
            </Button>
          </AlertDialogCancel>
          <Button color="danger" size="md" onClick={onConfirm} disabled={isDeleting}>
            {isDeleting ? '削除中...' : '削除'}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
